<template>  
  <main class="lg:mb-[600px] relative z-10 bg-backgroundBody dark:bg-dark">
      <!--=====================================
     Hero Section with Gradient
  ======================================-->
  <section
    class="pt-[137px] md:pt-[160px] xl:pt-[180px] pb-20 md:pb-[100px] relative overflow-hidden"
  >
    <!-- Gradient Background Wrapper -->
    <div
      id="hero-gradient-wrapper"
      class="absolute w-full h-full top-0 left-0 -z-10 blur-[35px] md:blur-[60px]"
    >
      <img
        src="@/assets/images/hero-gradient-background.png"
        alt="hero-gradient-background"
        id="hero-gradient"
        class="absolute left-1/2 top-1/2 -translate-x-1/2 max-md:-translate-y-[60%] md:-translate-y-1/2"
      />
    </div>
  
    <!-- Main Content Container -->
    <div class="container reveal-me">
      <div class="text-center">
        <!-- Status Badge -->
        <div class="rv-badge mb-5 md:mb-10">
          <span class="rv-badge-text">Open for new work</span>
        </div>
  
        <!-- Hero Heading -->
        <h1 class="mb-7 xl:mb-8">
          Elevate Your Brand<br />
          with <span class="font-instrument italic">Smart</span> Modern Solutions
        </h1>
  
        <!-- Hero Description -->
        <p class="mb-10 md:mb-14 xl:mb-[76px] max-w-xl lg:max-w-[750px] mx-auto">
          We design, build, and optimize digital experiences that leave a lasting impact—helping brands scale with confidence.
        </p>
  
        <!-- CTA Buttons -->
        <ul
          class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 list-none"
        >
          <!-- Primary CTA Button -->
          <li
            class="block md:inline-block w-[90%] mx-auto md:ml-auto md:mr-0 md:w-auto"
          >
          <router-link
            to="/portfolio"
            class="rv-button rv-button-secondary block md:inline-block"
          >
            <div class="rv-button-top">
              <span>Portfolio</span>
            </div>
            <div class="rv-button-bottom">
              <span>Portfolio</span>
            </div>
          </router-link>
  
          </li>
          <!-- Secondary CTA Button -->
          <li
            class="block md:inline-block w-[90%] mx-auto md:mr-auto md:ml-0 md:w-auto"
          >
            <router-link
              to="/services"
              class="rv-button rv-button-white block md:inline-block"
            >
              <div class="rv-button-top">
                <span>Our Services</span>
              </div>
              <div class="rv-button-bottom">
                <span>Our Services</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </section>
  
  
  
      
      <!--==================================
     About Content Area With Logo
  ===================================-->
<BrandSpinner/>
  
      
      <!--=====================================
     Portfolio Section
  ======================================-->
  <section
    class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]"
  >
    <div class="container">
      <!-- Section Header -->
      <div
        class="flex flex-col md:flex-row gap-y-6 gap-x-10 justify-center lg:justify-start items-start md:items-end mb-10 md:mb-20"
      >
        <div class="flex-1">
          <div class="rv-badge reveal-me">
            <span class="rv-badge-text">Our Portfolio</span>
          </div>
          <h2 class="text-appear mt-3 md:mt-5">
            Success Stories in
            <span class="font-instrument italic">Digital</span> Innovation
          </h2>
        </div>
        <div class="flex-1">
          <p class="text-appear">
            Discover how Neue Media brings brands to life with impactful digital
            solutions.Our portfolio showcases quality and creativity in every
            project.
          </p>
        </div>
      </div>
  
      <!-- Portfolio Grid -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div class="relative group cursor-pointer reveal-me">
          <router-link to="/pairboard" class="w-full">
            <figure class="overflow-hidden">
              <img
                class="w-full h-full block transition-all duration-500 group-hover:scale-125"
                src="@/assets/images/services/services-1.png"
                alt="Services Image"
              />
            </figure>
            <div
              class="bg-secondary/50 backdrop-blur w-[calc(100%-20px)] py-2.5 pl-5 sm:pl-10 mx-2.5 absolute bottom-4 pr-2.5 flex items-center justify-between group-hover:scale-[1.01] transition-all duration-500"
            >
              <h3 class="text-white text-2xl lg:text-[32px]">Pairboard</h3>
              <figure
                class="bg-primary p-7 lg:p-8 cursor-pointer relative overflow-hidden"
              >
                <img
                  src="@/assets/images/icons/arrow-Icon.svg"
                  alt="Arrow Icon"
                  class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 group-hover:-translate-y-12 group-hover:translate-x-8 transition-all duration-500 opacity-100 group-hover:opacity-0"
                />
                <img
                  src="@/assets/images/icons/arrow-Icon.svg"
                  alt="Arrow Icon"
                  class="absolute translate-y-8 -translate-x-12 transition-all duration-500 opacity-0 group-hover:opacity-100 group-hover:-translate-x-2.5 group-hover:-translate-y-2"
                />
              </figure>
            </div>
          </router-link>
        </div>
        <div class="relative group cursor-pointer reveal-me">
          <router-link to="/off-melrose" class="w-full">
            <figure class="overflow-hidden">
              <img
                class="w-full h-full block transition-all duration-500 group-hover:scale-125"
                src="@/assets/images/services/services-2.png"
                alt="Services Image"
              />
            </figure>
            <div
              class="bg-secondary/50 backdrop-blur w-[calc(100%-20px)] py-2.5 pl-5 sm:pl-10 mx-2.5 absolute bottom-4 pr-2.5 flex items-center justify-between group-hover:scale-[1.01] transition-all duration-500"
            >
              <h3 class="text-white text-2xl lg:text-[32px]">
                Off Melrose
              </h3>
              <figure
                class="bg-primary p-7 lg:p-8 cursor-pointer relative overflow-hidden"
              >
                <img
                  src="@/assets/images/icons/arrow-Icon.svg"
                  alt="Arrow Icon"
                  class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 group-hover:-translate-y-12 group-hover:translate-x-8 transition-all duration-500 opacity-100 group-hover:opacity-0"
                />
                <img
                  src="@/assets/images/icons/arrow-Icon.svg"
                  alt="Arrow Icon"
                  class="absolute translate-y-8 -translate-x-12 transition-all duration-500 opacity-0 group-hover:opacity-100 group-hover:-translate-x-2.5 group-hover:-translate-y-2"
                />
              </figure>
            </div>
          </router-link>
        </div>
        <div class="relative group cursor-pointer reveal-me">
          <router-link to="/finify" class="w-full">
            <figure class="overflow-hidden">
              <img
                class="w-full h-full block transition-all duration-500 group-hover:scale-125"
                src="@/assets/images/services/services-3.png"
                alt="Services Image"
              />
            </figure>
            <div
              class="bg-secondary/50 backdrop-blur w-[calc(100%-20px)] py-2.5 pl-5 sm:pl-10 mx-2.5 absolute bottom-4 pr-2.5 flex items-center justify-between group-hover:scale-[1.01] transition-all duration-500"
            >
              <h3 class="text-white text-2xl lg:text-[32px]">Finify</h3>
              <figure
                class="bg-primary p-7 lg:p-8 cursor-pointer relative overflow-hidden"
              >
                <img
                  src="@/assets/images/icons/arrow-Icon.svg"
                  alt="Arrow Icon"
                  class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 group-hover:-translate-y-12 group-hover:translate-x-8 transition-all duration-500 opacity-100 group-hover:opacity-0"
                />
                <img
                  src="@/assets/images/icons/arrow-Icon.svg"
                  alt="Arrow Icon"
                  class="absolute translate-y-8 -translate-x-12 transition-all duration-500 opacity-0 group-hover:opacity-100 group-hover:-translate-x-2.5 group-hover:-translate-y-2"
                />
              </figure>
            </div>
          </router-link>
        </div>
        <div class="relative group cursor-pointer reveal-me">
          <router-link to="/blingram" class="w-full">
            <figure class="overflow-hidden">
              <img
                class="w-full h-full block transition-all duration-500 group-hover:scale-125"
                src="@/assets/images/services/services-4.png"
                alt="Services Image"
              />
            </figure>
            <div
              class="bg-secondary/50 backdrop-blur w-[calc(100%-20px)] py-2.5 pl-5 sm:pl-10 mx-2.5 absolute bottom-4 pr-2.5 flex items-center justify-between group-hover:scale-[1.01] transition-all duration-500"
            >
              <h3 class="text-white text-2xl lg:text-[32px]">Blingram</h3>
              <figure
                class="bg-primary p-7 lg:p-8 cursor-pointer relative overflow-hidden"
              >
                <img
                  src="@/assets/images/icons/arrow-Icon.svg"
                  alt="Arrow Icon"
                  class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 group-hover:-translate-y-12 group-hover:translate-x-8 transition-all duration-500 opacity-100 group-hover:opacity-0"
                />
                <img
                  src="@/assets/images/icons/arrow-Icon.svg"
                  alt="Arrow Icon"
                  class="absolute translate-y-8 -translate-x-12 transition-all duration-500 opacity-0 group-hover:opacity-100 group-hover:-translate-x-2.5 group-hover:-translate-y-2"
                />
              </figure>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
  
      
      <section
    class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative overflow-hidden"
  >
    <!-- Clients Logo Marquee -->
    <div class="marquee-container reveal-me">
      <div class="flex items-center justify-between py-2.5 pb-5">
        <div class="flex items-center gap-6 mr-5">
          <span
            class="text-5xl sm:text-[55px] md:text-[67px] lg:text-[84px] xl:text-8xl font-normal leading-tight xl:leading-[1.1] tracking-[-2px] xl:tracking-[-2.88px] text-nowrap"
          >
          Digital Transformation
        </span>
          <span class="mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20.002 0C20.002 0 19.789 11.2169 24.2871 15.7149C28.785 20.2129 40.002 20 40.002 20C40.002 20 28.785 19.7871 24.2871 24.2851C19.789 28.7831 20.002 40 20.002 40C20.002 40 20.2149 28.7831 15.7168 24.2851C11.2189 19.7871 0.00195312 20 0.00195312 20C0.00195312 20 11.2189 20.2129 15.7168 15.7149C20.2149 11.2169 20.002 0 20.002 0Z"
                class="fill-black dark:fill-white"
              />
            </svg>
          </span>
        </div>
        <div class="flex items-center gap-6 mr-5">
          <span
            class="text-5xl sm:text-[55px] md:text-[67px] lg:text-[84px] xl:text-8xl font-normal leading-tight xl:leading-[1.1] tracking-[-2px] xl:tracking-[-2.88px] text-nowrap"
          >
          Emerging Tech
          </span>
          <span class="mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20.002 0C20.002 0 19.789 11.2169 24.2871 15.7149C28.785 20.2129 40.002 20 40.002 20C40.002 20 28.785 19.7871 24.2871 24.2851C19.789 28.7831 20.002 40 20.002 40C20.002 40 20.2149 28.7831 15.7168 24.2851C11.2189 19.7871 0.00195312 20 0.00195312 20C0.00195312 20 11.2189 20.2129 15.7168 15.7149C20.2149 11.2169 20.002 0 20.002 0Z"
                class="fill-black dark:fill-white"
              />
            </svg>
          </span>
        </div>
        <div class="flex items-center gap-6 mr-5">
          <span
            class="text-5xl sm:text-[55px] md:text-[67px] lg:text-[84px] xl:text-8xl font-normal leading-tight xl:leading-[1.1] tracking-[-2px] xl:tracking-[-2.88px] text-nowrap"
          >
          Digital Transformation
        </span>
          <span class="mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20.002 0C20.002 0 19.789 11.2169 24.2871 15.7149C28.785 20.2129 40.002 20 40.002 20C40.002 20 28.785 19.7871 24.2871 24.2851C19.789 28.7831 20.002 40 20.002 40C20.002 40 20.2149 28.7831 15.7168 24.2851C11.2189 19.7871 0.00195312 20 0.00195312 20C0.00195312 20 11.2189 20.2129 15.7168 15.7149C20.2149 11.2169 20.002 0 20.002 0Z"
                class="fill-black dark:fill-white"
              />
            </svg>
          </span>
        </div>
        <div class="flex items-center gap-6 mr-5">
          <span
            class="text-5xl sm:text-[55px] md:text-[67px] lg:text-[84px] xl:text-8xl font-normal leading-tight xl:leading-[1.1] tracking-[-2px] xl:tracking-[-2.88px] text-nowrap"
          >
          AI & Automation
          </span>
          <span class="mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20.002 0C20.002 0 19.789 11.2169 24.2871 15.7149C28.785 20.2129 40.002 20 40.002 20C40.002 20 28.785 19.7871 24.2871 24.2851C19.789 28.7831 20.002 40 20.002 40C20.002 40 20.2149 28.7831 15.7168 24.2851C11.2189 19.7871 0.00195312 20 0.00195312 20C0.00195312 20 11.2189 20.2129 15.7168 15.7149C20.2149 11.2169 20.002 0 20.002 0Z"
                class="fill-black dark:fill-white"
              />
            </svg>
          </span>
        </div>
        <div class="flex items-center gap-6 mr-5">
          <span
            class="text-5xl sm:text-[55px] md:text-[67px] lg:text-[84px] xl:text-8xl font-normal leading-tight xl:leading-[1.1] tracking-[-2px] xl:tracking-[-2.88px] text-nowrap"
          >
            Creative Development
          </span>
          <span class="mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20.002 0C20.002 0 19.789 11.2169 24.2871 15.7149C28.785 20.2129 40.002 20 40.002 20C40.002 20 28.785 19.7871 24.2871 24.2851C19.789 28.7831 20.002 40 20.002 40C20.002 40 20.2149 28.7831 15.7168 24.2851C11.2189 19.7871 0.00195312 20 0.00195312 20C0.00195312 20 11.2189 20.2129 15.7168 15.7149C20.2149 11.2169 20.002 0 20.002 0Z"
                class="fill-black dark:fill-white"
              />
            </svg>
          </span>
        </div>
        <div class="flex items-center gap-6 mr-5">
          <span
            class="text-5xl sm:text-[55px] md:text-[67px] lg:text-[84px] xl:text-8xl font-normal leading-tight xl:leading-[1.1] tracking-[-2px] xl:tracking-[-2.88px] text-nowrap"
          >
            Visual Design
          </span>
          <span class="mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20.002 0C20.002 0 19.789 11.2169 24.2871 15.7149C28.785 20.2129 40.002 20 40.002 20C40.002 20 28.785 19.7871 24.2871 24.2851C19.789 28.7831 20.002 40 20.002 40C20.002 40 20.2149 28.7831 15.7168 24.2851C11.2189 19.7871 0.00195312 20 0.00195312 20C0.00195312 20 11.2189 20.2129 15.7168 15.7149C20.2149 11.2169 20.002 0 20.002 0Z"
                class="fill-black dark:fill-white"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  
    <!-- Reverse -->
    <div class="marquee-reverse-container reveal-me border-t dark:border-dark">
      <div class="flex items-center justify-between py-2.5">
        <div class="flex items-center gap-6 mr-5">
          <span
            class="text-5xl sm:text-[55px] md:text-[67px] lg:text-[84px] xl:text-8xl font-normal leading-tight xl:leading-[1.1] tracking-[-2px] xl:tracking-[-2.88px] text-nowrap"
          >
          Web & App Development 
        </span>
          <span class="mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20.002 0C20.002 0 19.789 11.2169 24.2871 15.7149C28.785 20.2129 40.002 20 40.002 20C40.002 20 28.785 19.7871 24.2871 24.2851C19.789 28.7831 20.002 40 20.002 40C20.002 40 20.2149 28.7831 15.7168 24.2851C11.2189 19.7871 0.00195312 20 0.00195312 20C0.00195312 20 11.2189 20.2129 15.7168 15.7149C20.2149 11.2169 20.002 0 20.002 0Z"
                class="fill-black dark:fill-white"
              />
            </svg>
          </span>
        </div>
        <div class="flex items-center gap-6 mr-5">
          <span
            class="text-5xl sm:text-[55px] md:text-[67px] lg:text-[84px] xl:text-8xl font-normal leading-tight xl:leading-[1.1] tracking-[-2px] xl:tracking-[-2.88px] text-nowrap"
          >
          Emerging Tech
        </span>
          <span class="mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20.002 0C20.002 0 19.789 11.2169 24.2871 15.7149C28.785 20.2129 40.002 20 40.002 20C40.002 20 28.785 19.7871 24.2871 24.2851C19.789 28.7831 20.002 40 20.002 40C20.002 40 20.2149 28.7831 15.7168 24.2851C11.2189 19.7871 0.00195312 20 0.00195312 20C0.00195312 20 11.2189 20.2129 15.7168 15.7149C20.2149 11.2169 20.002 0 20.002 0Z"
                class="fill-black dark:fill-white"
              />
            </svg>
          </span>
        </div>
        <div class="flex items-center gap-6 mr-5">
          <span
            class="text-5xl sm:text-[55px] md:text-[67px] lg:text-[84px] xl:text-8xl font-normal leading-tight xl:leading-[1.1] tracking-[-2px] xl:tracking-[-2.88px] text-nowrap"
          >
            Search Engine Optimization
          </span>
          <span class="mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20.002 0C20.002 0 19.789 11.2169 24.2871 15.7149C28.785 20.2129 40.002 20 40.002 20C40.002 20 28.785 19.7871 24.2871 24.2851C19.789 28.7831 20.002 40 20.002 40C20.002 40 20.2149 28.7831 15.7168 24.2851C11.2189 19.7871 0.00195312 20 0.00195312 20C0.00195312 20 11.2189 20.2129 15.7168 15.7149C20.2149 11.2169 20.002 0 20.002 0Z"
                class="fill-black dark:fill-white"
              />
            </svg>
          </span>
        </div>
        <div class="flex items-center gap-6 mr-5">
          <span
            class="text-5xl sm:text-[55px] md:text-[67px] lg:text-[84px] xl:text-8xl font-normal leading-tight xl:leading-[1.1] tracking-[-2px] xl:tracking-[-2.88px] text-nowrap"
          >
            EST. 2024
          </span>
          <span class="mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20.002 0C20.002 0 19.789 11.2169 24.2871 15.7149C28.785 20.2129 40.002 20 40.002 20C40.002 20 28.785 19.7871 24.2871 24.2851C19.789 28.7831 20.002 40 20.002 40C20.002 40 20.2149 28.7831 15.7168 24.2851C11.2189 19.7871 0.00195312 20 0.00195312 20C0.00195312 20 11.2189 20.2129 15.7168 15.7149C20.2149 11.2169 20.002 0 20.002 0Z"
                class="fill-black dark:fill-white"
              />
            </svg>
          </span>
        </div>
        <div class="flex items-center gap-6 mr-5">
          <span
            class="text-5xl sm:text-[55px] md:text-[67px] lg:text-[84px] xl:text-8xl font-normal leading-tight xl:leading-[1.1] tracking-[-2px] xl:tracking-[-2.88px] text-nowrap"
          >
            Based in Los Angeles
          </span>
          <span class="mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M20.002 0C20.002 0 19.789 11.2169 24.2871 15.7149C28.785 20.2129 40.002 20 40.002 20C40.002 20 28.785 19.7871 24.2871 24.2851C19.789 28.7831 20.002 40 20.002 40C20.002 40 20.2149 28.7831 15.7168 24.2851C11.2189 19.7871 0.00195312 20 0.00195312 20C0.00195312 20 11.2189 20.2129 15.7168 15.7149C20.2149 11.2169 20.002 0 20.002 0Z"
                class="fill-black dark:fill-white"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  </section>
  
  
  <section
    class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative overflow-hidden @@Spacing"
  >
    <div class="container">
      <div
        class="flex flex-col md:flex-row gap-y-3 gap-x-10 justify-center lg:justify-start items-start sm:items-center mb-16 md:mb-20"
      >
        <div class="flex-1">
          <h2 class="text-appear-2">
            Elevating Your <br />
            <span class="font-instrument italic">Digital</span> Presence
          </h2>
        </div>
        <div class="flex-1 max-w-lg">
          <p
            class="text-appear max-md:text-justify dark:text-colorText text-appear-2"
          >
            We craft expert digital solutions that elevate your brand, amplify your online presence, and drive real growth. From strategy to execution, we help you stand out and succeed in the digital landscape.
          </p>
        </div>
      </div>
    </div>
  
    <div
      class="flex max-xl:flex-wrap max-xl:gap-5 justify-center [&>*:not(:last-child)]:border-l dark:[&>*:not(:last-child)]:border-l-dark [&>*:last-child]:border-l dark:[&>*:last-child]:border-l-dark [&>*:last-child]:border-r dark:[&>*:last-child]:border-r-dark [&>*]:border-y dark:[&>*]:border-y-dark max-xl:[&>*:first-child]:border-r dark:max-xl:[&>*:first-child]:border-dark max-xl:[&>*:nth-child(2)]:border-r dark:max-xl:[&>*:nth-child(2)]:border-dark max-2xl:[&>*:nth-child(3)]:border-r dark:max-2xl:[&>*:nth-child(3)]:border-dark xl:px-5"
    >
      <!-- Research Card -->
      <div class="relative group overflow-hidden w-[360px] h-[500px] reveal-me">
        <div
          class="w-full h-full flex justify-center items-center absolute translate-y-0 group-hover:-translate-y-full transition-all opacity-100 group-hover:opacity-0 duration-700"
        >
          <h5 class="max-sm:text-3xl">Strategy</h5>
        </div>
  
        <div
          class="w-full h-full bg-secondary dark:bg-white p-8 absolute translate-y-full duration-700 transition-all group-hover:translate-y-0 group-hover:inset-0 z-10"
        >
          <router-link to="/strategy">
            <div class="mb-[55px] flex gap-1 items-center justify-between">
              <h5
                class="max-sm:text-3xl text-white dark:text-secondary opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[240ms]"
              >
               Strategy
              </h5>
              <span
                class="transition-all duration-1000 translate-x-20 group-hover:translate-x-0"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M5 16H27"
                    class="stroke-white dark:stroke-black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18 7L27 16L18 25"
                    class="stroke-white dark:stroke-black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </div>
            <p
              class="text-backgroundBody/70 dark:text-secondary/70 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[340ms]"
            >
              Unlock the full potential of your business with a tailored strategy. We help brands navigate growth with insights and data-driven decision-making across key areas such as:
            </p>
            <ul
              class="pl-4 mt-6 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[440ms]"
            >
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
                Brand Strategy (positioning, messaging, competitive differentiation)
              </li>
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Go-to-Market Strategy (launch planning, customer acquisition, scaling)
              </li>
              <li
              class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
            >
              Digital Strategy (SEO, content, social media, paid media)
            </li>
            </ul>
          </router-link>
        </div>
      </div>
  
      <!-- Alchemy Studio Card -->
      <div class="relative group overflow-hidden w-[360px] h-[500px] reveal-me">
        <div
          class="w-full h-full flex justify-center items-center absolute translate-y-0 group-hover:-translate-y-full transition-all opacity-100 group-hover:opacity-0 duration-700"
        >
          <h5 class="max-sm:text-3xl">Design</h5>
        </div>
  
        <div
          class="w-full h-full bg-secondary dark:bg-white p-8 absolute translate-y-full duration-700 transition-all group-hover:translate-y-0 group-hover:inset-0 z-10"
        >
          <router-link to="/design">
            <div class="mb-[55px] flex gap-1 items-center justify-between">
              <h5
                class="max-sm:text-3xl text-white dark:text-secondary opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[240ms]"
              >
                Design
              </h5>
              <span
                class="transition-all duration-1000 translate-x-20 group-hover:translate-x-0"
              >
                <svg
                  class="transition-all duration-1000 translate-x-20 group-hover:translate-x-0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M5 16H27"
                    class="stroke-white dark:stroke-black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18 7L27 16L18 25"
                    class="stroke-white dark:stroke-black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </div>
            <p
              class="text-backgroundBody/70 dark:text-secondary/70 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[340ms]"
            >
            Create visually stunning and user-friendly experiences that leave a lasting impression. Our design expertise spans across:
            </p>
            <ul
              class="pl-4 mt-6 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[440ms]"
            >
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Brand Identity (logos, typography, color palettes)
            </li>
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              UI/UX Design (app interfaces, web layouts, user experience optimization)
            </li>
            <li
            class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
          >
              Marketing Assets (social media graphics, ad creatives, presentations)
            </li>
            </ul>
        </router-link>
        </div>
      </div>
      <!-- Rhythms Media Card -->
      <div class="relative group overflow-hidden w-[360px] h-[500px] reveal-me">
        <div
          class="w-full h-full flex justify-center items-center absolute translate-y-0 group-hover:-translate-y-full transition-all opacity-100 group-hover:opacity-0 duration-700"
        >
          <h5 class="max-sm:text-3xl">Development</h5>
        </div>
  
        <div
          class="w-full h-full bg-secondary dark:bg-white p-8 absolute translate-y-full duration-700 transition-all group-hover:translate-y-0 group-hover:inset-0 z-10"
        >
          <router-link to="/development">
            <div class="mb-[55px] flex gap-1 items-center justify-between">
              <h5
                class="max-sm:text-3xl text-white dark:text-secondary opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[240ms]"
              >
              Development
              </h5>
              <span>
                <svg
                  class="transition-all duration-1000 translate-x-20 group-hover:translate-x-0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    d="M5 16H27"
                    class="stroke-white dark:stroke-black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18 7L27 16L18 25"
                    class="stroke-white dark:stroke-black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </div>
            <p
              class="text-backgroundBody/70 dark:text-secondary/70 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[340ms]"
            >
            Transform your vision into high-performance digital experiences with our expert development services. We specialize in:
            </p>
            <ul
              class="pl-4 mt-6 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[440ms]"
            >
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Web Development (custom websites, eCommerce, CMS solutions)
            </li>
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Mobile App Development (iOS, Android, cross-platform solutions)
            </li>
            <li
            class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
          >
          Custom Software (API integrations, automation, backend systems)
            </li>
            </ul>
        </router-link>
        </div>
      </div>
  
      <!-- Sound Studios  Card -->
  
      <div
        class="relative group overflow-hidden w-[360px] h-[500px] reveal-me justify-self-center"
      >
        <div
          class="w-full h-full flex justify-center items-center absolute translate-y-0 group-hover:-translate-y-full transition-all opacity-100 group-hover:opacity-0 duration-700"
        >
          <h5 class="max-sm:text-3xl">Marketing</h5>
        </div>
  
        <div
          class="w-full h-full bg-secondary dark:bg-white p-8 absolute translate-y-full duration-700 transition-all group-hover:translate-y-0 group-hover:inset-0 z-10"
        >
          <router-link to="/marketing">
            <div class="mb-[55px] flex gap-1 items-center justify-between">
              <h5
                class="max-sm:text-3xl text-white t dark:text-secondary opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[240ms]"
              >
              Marketing
              </h5>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  class="transition-all duration-1000 translate-x-20 group-hover:translate-x-0"
                >
                  <path
                    d="M5 16H27"
                    class="stroke-white dark:stroke-black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18 7L27 16L18 25"
                    class="stroke-white dark:stroke-black"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </div>
            <p
              class="text-backgroundBody/70 dark:text-secondary/70 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[340ms]"
            >
            Drive growth and engagement with data-driven marketing strategies designed to make an impact. Our expertise includes:
          </p>
            <ul
              class="pl-4 mt-6 opacity-0 translate-y-5 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-[800ms] delay-[440ms]"
            >
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              SEO & Content Strategy (organic growth, keyword optimization, blog content)
            </li>
              <li
                class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed"
              >
              Paid Advertising (Google Ads, social media campaigns, conversion optimization)
            </li>
            <li
            class="text-backgroundBody/70 dark:text-secondary/70 list-disc text-base leading-relexed">
            Brand Growth (social media management, email marketing, influencer collaborations)
            </li>
            </ul>
          </router-link>
        </div>
      </div>
    </div>
  </section>
  
      
      <!--=====================================
     FAQ Section
  ======================================-->
  <section
    class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px] relative overflow-hidden"
  >
    <div
      class="absolute scale-y-[3.4] sm:scale-y-[1.6] md:scale-y-[1.5] lg:scale-y-[1.5] xl:scale-y-[1.4] 2xl:scale-y-[1] scale-x-[2.8] md:scale-x-[1.9] lg:scale-x-[1.7] left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 -z-30"
    >
      <img src="@/assets/images/gradient-bg.png" alt="gradient-bg" />
    </div>
    <div class="container">
      <!-- FAQ Section Title -->
      <h2 class="mb-10 md:mb-20 text-center text-appear">
        Frequently Asked <span class="font-instrument italic">Questions</span>
      </h2>
  
      <!-- FAQ Items Container -->
      <div
        class="max-w-[900px] w-full mx-auto [&>*:not(:last-child)]:mb-6 reveal-me"
      >
        <!-- FAQ Item 1 -->
        <div
          class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
        >
          <div
            class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
          >
            <h3
              class="text-lg sm:text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-10"
            >
              What services does Neue Media offer?
            </h3>
            <div class="accordion-header-icon dark:border-dark"></div>
          </div>
          <p
            class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
          >
          Neue Media delivers cutting-edge digital solutions, transforming brands with sleek web design, powerful development, and high-impact SEO. From mobile app innovation to bold branding and strategic digital marketing, we craft experiences that captivate and convert. Our advanced email automation tools elevate UX with intuitive sidebars, smart navigation, and conversion-driven messaging—ensuring every interaction moves your audience closer to action.
          </p>
        </div>
  
        <!-- FAQ Item 2 -->
        <div
          class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
        >
          <div
            class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
          >
            <h3
              class="text-lg sm:text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-11"
            >
            How involved will I be in the project?
          </h3>
            <div class="accordion-header-icon dark:border-dark"></div>
          </div>
          <p
            class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
          >
          Your level of involvement is up to you! Whether you prefer hands-on collaboration with regular check-ins or a more hands-off approach while we handle the details, we adapt to your workflow and keep you informed at key milestones.
          </p>
        </div>
  
        <!-- FAQ Item 3 -->
        <div
          class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
        >
          <div
            class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
          >
            <h3
              class="text-lg sm:text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-9"
            >
              Can Neue Media handle both small and large-scale projects?
            </h3>
            <div class="accordion-header-icon dark:border-dark"></div>
          </div>
          <p
            class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
          >
            Yes! We work with startups and enterprises alike, scaling solutions to fit your needs.
          </p>
        </div>
  
        <!-- FAQ Item 4 -->
        <div
          class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
        >
          <div
            class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
          >
            <h3
              class="text-lg sm:text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-8"
            >
            How much does a typical project cost?
          </h3>
            <div class="accordion-header-icon dark:border-dark"></div>
          </div>
          <p
            class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
          >
          Pricing depends on project complexity. We offer transparent pricing and custom quotes based on your specific needs.
          </p>
        </div>
  
        <!-- FAQ Item 5 -->
        <div
          class="accordion-item overflow-hidden bg-backgroundBody dark:bg-dark border border-white dark:border-[#151515] duration-300"
        >
          <div
            class="accordion-header relative cursor-pointer py-5 md:py-[35px] max-md:px-5 md:px-10"
          >
            <h3
              class="text-lg sm:text-xl md:text-[25px] font-normal sm:font-bold md:leading-[25.2px] md:tracking-normal max-md:inline-block max-lg:pr-8"
            >
              Do you provide post-launch support?
            </h3>
            <div class="accordion-header-icon dark:border-dark"></div>
          </div>
          <p
            class="accordion-body max-md:text-sm max-md:px-5 md:px-10 duration-300 h-0"
          >
            Yes! We offer ongoing maintenance, updates, and support to ensure long-term success.
          </p>
        </div>
      </div>
    </div>
  </section>
  
      <!--=====================================
     CTA Section
  ======================================-->
  <section
    class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-[70px] lg:pb-[140px] relative"
  >
    <div class="container">
      <!-- CTA Heading -->
      <h2
        class="text-center xl:text-[96px] font-normal xl:leading-[1.1] xl:tracking-[-2.88px]"
      >
        Got Questions?
        <span class="font-instrument sm:mt-10 italic block max-md:inline-block"
          >We’ve Got Answers</span
        >
      </h2>
  
      <ul
      class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 list-none"
    >
        <!-- Primary CTA Button -->
        <li
          class="block md:inline-block w-[90%] mx-auto md:ml-auto md:mr-0 md:w-auto"
        >
        
        </li>
        <!-- Secondary CTA Button -->
        <li
          class="block md:inline-block w-[90%] mx-auto md:mr-auto md:ml-0 md:w-auto"
        >
          <router-link
            to="/contact"
            class="rv-button rv-button-primary block md:inline-block"
          >
            <div class="rv-button-top contact-btn-lg">
              <span>Let's Connect</span>
            </div>
            <div class="rv-button-bottom contact-btn-lg">
              <span>Let's Connect</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </section>
  
  </main>
  
  <!--=====================================
     Footer Section
  ======================================-->
  <FooterComponent/>
  
  </template>
  
<script>
  import FooterComponent from '@/components/FooterComponent.vue'
  import BrandSpinner from '@/components/BrandSpinner.vue'
  import { Animations } from '@/legacy/initLegacy'
  import ScrollTrigger from 'gsap/ScrollTrigger';
  import { Components } from '@/legacy/initLegacy'   // ← new import

  export default {
    name: 'HomePage',
    components: {
      FooterComponent,
      BrandSpinner,
    },
    mounted() {
    this.$nextTick(() => {
        Animations.initTextReveal();
        setTimeout(() => { ScrollTrigger.refresh(true); }, 200);
        Components.initFAQ()

    });
    },
    activated() {
    this.$nextTick(() => {
        Animations.initTextReveal();
        setTimeout(() => { ScrollTrigger.refresh(true); }, 200);
    });
    }

  }
  </script>
  
  